import { renderForm } from './form/renderForm.js';

// TODO: Durante el desarrollo veremos que parte se queda en login y qué en renderForm
export async function login() {
  return renderForm();
}
